import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";
import Learning from "./pages/Learning";
import Guide from "./pages/Guide";
import InteractiveForm from "./pages/InteractiveForm";
import Admin from "./pages/Admin";
import GovSearchEngine from "./components/GovSearchEngine";

import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import "@/App.css";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");

    if (token && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
  }, []);

  const ProtectedRoute = ({ children }) => {
    return isAuthenticated ? children : <Navigate to="/login" replace />;
  };

  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          {/* AUTH ROUTES */}
          <Route path="/login" element={<Login setAuth={setIsAuthenticated} setUser={setUser} />} />
          <Route path="/register" element={<Register setAuth={setIsAuthenticated} setUser={setUser} />} />

          {/* HOME */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home user={user} />
              </ProtectedRoute>
            }
          />

          {/* ✅ GOV SEARCH (ONLY OPENS VIA BUTTON) */}
          <Route
            path="/gov-search"
            element={
              <ProtectedRoute>
                <GovSearchEngine />
              </ProtectedRoute>
            }
          />

          {/* OTHER ROUTES */}
          <Route path="/learning" element={<ProtectedRoute><Learning /></ProtectedRoute>} />
          <Route path="/guide/:topic" element={<ProtectedRoute><Guide /></ProtectedRoute>} />
          <Route path="/form/:topic" element={<ProtectedRoute><InteractiveForm /></ProtectedRoute>} />
          <Route path="/admin" element={<Admin />} />
        </Routes>

        <Toaster position="top-center" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
